import { Link, useLocation } from "react-router-dom";
import { useDocumentMeta } from "@/hooks/useDocumentMeta";

export default function NotFound() {
  const location = useLocation();

  useDocumentMeta({
    title: "页面不存在 - 亚洲一区二区在线",
    description: "抱歉，你访问的页面不存在或已被移除，返回首页继续浏览亚洲影视内容。",
    keywords: "页面不存在,404,亚洲一区二区在线",
  });

  return (
    <div className="mx-auto flex w-full flex-col items-center justify-center px-4 py-24 text-center md:px-6">
      <span className="flex h-20 w-20 items-center justify-center rounded-full bg-primary-50 text-primary-500">
        <i className="ri-movie-2-line text-4xl"></i>
      </span>
      <p className="mt-6 font-heading text-6xl font-black text-foreground-950 md:text-8xl">
        404
      </p>
      <h1 className="mt-4 font-heading text-xl font-bold text-foreground-900 md:text-2xl">
        很抱歉，你访问的页面不存在
      </h1>
      <p className="mt-2 text-sm text-foreground-500">
        页面可能已被移除或链接有误：
        <span className="ml-1 font-mono text-foreground-600">{location.pathname}</span>
      </p>
      <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
        <Link
          to="/"
          className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
        >
          <i className="ri-home-5-line"></i>
          返回首页
        </Link>
        <Link
          to="/category/movie"
          className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 px-5 py-3 text-sm font-medium text-foreground-700 transition-colors hover:bg-background-100"
        >
          <i className="ri-compass-3-line"></i>
          去逛影视分类
        </Link>
      </div>
    </div>
  );
}